import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DocumentsLegacyRedux from '../../components/Documents';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import { deleteFaqsNotesDocuments } from 'src/store/actions/faqsNotesDocuments';
import { selectDocuments } from 'src/store/selectors/faqsNotesDocuments';
import { setSearch, clearSearch } from 'src/store/actions/search';
import Loader from '../../components/Loader';
import { sortDocumentsList } from 'src/helpers/CommonHelpers';
import { DocumentFormData } from 'src/utils/S3UploadDocumentsUtility';
import {
  useDocumentSave,
  UseDocumentSaveReturn,
} from 'src/pages/SharedPageCustomHooks/UseDocumentSave/useDocumentSave';

interface Contact {
  id: string;
  firstname: string;
  lastname: string;
}

interface ContactDocumentsProps {
  contact: Contact;
}

const ContactDocuments = ({ contact }: ContactDocumentsProps) => {
  const [loading, setLoading] = useState<boolean>(true);
  const user = useSelector(selectAuthenticatedUser);
  const documents = useSelector(selectDocuments);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearSearch());
    const timer = setTimeout(() => setLoading(false), 3000);
    return () => clearTimeout(timer);
  }, [dispatch]);

  const { saveDocument }: UseDocumentSaveReturn = useDocumentSave({
    customErrorMessage:
      'Failed to upload this contact document. Please try again or contact Juniper support if the issue persists.',
  });

  const onSave = async (document: DocumentFormData): Promise<void> => {
    await saveDocument(document, contact.id, user.id);
  };

  const onDeleteFaqsNotesDocuments = (document: DocumentFormData): void => {
    document.Type = 'DOCUMENTS';
    dispatch(deleteFaqsNotesDocuments(document));
  };

  const sortDocuments = sortDocumentsList(documents);

  return loading ? (
    <Loader />
  ) : (
    <DocumentsLegacyRedux
      breadcrumb={`${contact.firstname} ${contact.lastname}`}
      documents={sortDocuments}
      onSaveDocument={(document: DocumentFormData) => onSave(document)}
      onDeleteDocument={(document: any) => onDeleteFaqsNotesDocuments(document)}
      onSearch={(e: any) =>
        dispatch(setSearch({ documents: e.target.value.trim() }))
      }
      labelName={'Manuals & Documents'}
      from={'Contact'}
    />
  );
};

export default ContactDocuments;
